import React from 'react';
import { DetailsListItem } from '../DetailsListItem/DetailsListItem';
export const DetailsList = ({ children }) => React.createElement("div", null, children);
DetailsList.Item = DetailsListItem;
